import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import OrderTab from "./OrderTab";

function Orders () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={1}>
        <OrderTab />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
